import axios from 'axios'
import {Message} from 'element-ui'
import Vue from 'vue'
import store from '../store'
let vm = new Vue();
axios.interceptors.request.use(config => {
  return config;
}, err => {
  return Promise.resolve(err);
})
axios.interceptors.response.use(data => {
  if (data.status && data.status == 200 && data.data.status == 'error') {
    Message.error({message: data.data.msg});
    return;
  } else if (data.data.code == 510) {
    store.commit('logout');
    window.location.href = vm.$baseUrl;
  }
  if(data.headers.authorization && store.state && store.state.user){
    let user = store.state.user;
    if(!data.headers.checklogin){
      //根据 checklogin 参数判断请求是否来自 LarkXR 接口。由于 LarkXR 接口会返回 checklogin 参数，而开发者平台不会，
      // 因此可以通过检查该参数来判断。如果请求来自 LarkXR 接口，则无需更新 token。
      user.token = data.headers.authorization;
    }
    store.commit('login',user)
  }
  return data;
}, err => {
  console.log(err)
/*  if (err.response.status == 504 || err.response.status == 404) {
    Message.error({message: '服务器被吃了⊙﹏⊙∥'});
  } else if (err.response.status == 403) {
    Message.error({message: '权限不足,请联系管理员!'});
  } else if(err.response.status == 401){
    store.commit('logout');
    window.location.href = vm.$baseUrl;
  }else {
    Message.error({message: '未知错误!'});
  }*/
  return Promise.resolve(err);
})

export const postRequest = (url, params) => {
  axios.defaults.withCredentials = true;
  var headers = {};
  if (url == "/uacUser/login") {
    headers = {
      'Content-Type': 'application/x-www-form-urlencoded',
      'captchaId': params.captchaId,
      'Accept-Language':'zh-CN',
    }
  } else {
    headers = {
      'Content-Type': 'application/x-www-form-urlencoded',
      'authorization': store.state.user ?  store.state.user.token : null,
      'Accept-Language':'zh-CN',
    }
  }
  return axios({
    method: 'post',
    url: `${vm.$apiUrl}${url}`,
    data: params,
    transformRequest: [function (data) {
      let ret = ''
      for (let it in data) {
        ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
      }
      return ret
    }],
    headers: headers
  });
}

export const downloadRequest = (url, params) => {
  axios.defaults.withCredentials = true;
  return axios({
    method: 'post',
    url: `${vm.$apiUrl}${url}`,
    data: params,
    responseType : 'blob',
    transformRequest: [function (data) {
      let ret = ''
      for (let it in data) {
        ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
      }
      return ret
    }],
    headers:{
      'Content-Type': 'application/octet-stream',
      'authorization': store.state.user ?  store.state.user.token : null,
      'Accept-Language':'zh-CN',
    }
  });
}
export const postMultipartRequest = (url, params) => {
  axios.defaults.withCredentials = true;
  return axios({
    method: 'post',
    url: `${vm.$apiUrl}${url}`,
    data: params,
    headers: {
      'Content-Type': 'multipart/form-data',
      'authorization': store.state.user ?  store.state.user.token : null,
      'Accept-Language':'zh-CN',
    }
  });
}
export const postRequestJson = (url, params,captchaId) => {
  var headers = {};
  if ((url == "/uacUser/login" || url == "/uacUser/sendSmsCode") && captchaId != null) {
    headers = {
      'Content-Type': 'application/json; charset=utf-8',
      'captchaId': captchaId,
      'Accept-Language':'zh-CN',
    }
  }else {
    headers = {
      'Content-Type': 'application/json; charset=utf-8',
      'authorization': store.state.user ?  store.state.user.token : null,
      'Accept-Language':'zh-CN',
    }
  }
  axios.defaults.withCredentials = true;
  return axios({
    method: 'post',
    url: `${vm.$apiUrl}${url}`,
    data: params,
    headers:headers
  });
}

//异步调用
export const getRequest = (url, params,captchaId) => {
  axios.defaults.withCredentials = true;
  var headers = {};
  if (url == "/uacUser/sendSmsCode" && captchaId != null) {
    headers = {
      'Content-Type': 'application/json; charset=utf-8',
      'captchaId': captchaId,
      'Accept-Language':'zh-CN',
    }
    console.log(headers)
  }else {
    headers = {
      'Content-Type': 'application/json; charset=utf-8',
      'authorization': store.state.user ?  store.state.user.token : null,
      'Accept-Language':'zh-CN',
    }
  }
  return axios({
    method: 'get',
    url: `${vm.$apiUrl}${url}`,
    params: params,
    transformRequest: [function (data) {
      let ret = ''
      for (let it in data) {
        ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
      }
      return ret
    }],
    headers:headers
  });
}

export const deleteRequest = (url, params) => {
  axios.defaults.withCredentials = true;
  return axios({
    method: 'post',
    url: `${vm.$apiUrl}${url}`,
    data: params,
    transformRequest: [function (data) {
      let ret = ''
      for (let it in data) {
        ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
      }
      return ret
    }],
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'authorization': store.state.user ?  store.state.user.token : null,
      'Accept-Language':'zh-CN',
    }
  });
}
export const getRequestFile = (url, params,captchaId) => {
  axios.defaults.withCredentials = true;
  var headers = {
    'Content-Type': 'application/json; charset=utf-8',
    'authorization': store.state.user ?  store.state.user.token : null,
    'Accept-Language':'zh-CN',
  }
  return axios({
    method: 'get',
    url: `${vm.$apiUrl}${url}`,
    params: params,
    responseType : 'blob',
    transformRequest: [function (data) {
      let ret = ''
      for (let it in data) {
        ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
      }
      return ret
    }],
    headers:headers
  });
}

